import React from 'react';
import { Inbox } from 'lucide-react';
import { Spinner } from 'react-bootstrap';
import '../ManagementPage.css';
import ColumnInfoButton from './ColumnInfoButton';
import SubColumn from './SubColumn';

interface IncomingColumnProps {
    /** Felanmälningar (issues) rendered as cards. */
    issueItems: React.ReactNode;
    issueCount: number;
    /** Underhåll + kontroller rendered as cards. */
    maintenanceItems: React.ReactNode;
    maintenanceCount: number;
    loading: boolean;
    /** Optional info tooltip shown next to the column title. */
    titleInfo?: string;
    /** Optional footer at the bottom of the Felanmälningar subcolumn (e.g. snoozed). */
    issueFooter?: React.ReactNode;
    /** Optional footer at the bottom of the Underhåll & kontroller subcolumn. */
    maintenanceFooter?: React.ReactNode;
}

/**
 * "Att hantera" column, split into two subcolumns: Felanmälningar on the left,
 * Underhåll & kontroller on the right. Each subcolumn scrolls its own list
 * and has its own optional footer (e.g. an independent snoozed section).
 */
const IncomingColumn: React.FC<IncomingColumnProps> = ({
    issueItems,
    issueCount,
    maintenanceItems,
    maintenanceCount,
    loading,
    titleInfo,
    issueFooter,
    maintenanceFooter
}) => {
    const totalCount = issueCount + maintenanceCount;

    return (
        <div className="management-column management-column--wide h-100">
            <div className="management-column__header">
                <Inbox size={20} />
                <span className="management-column__title">Att hantera</span>
                {titleInfo && (
                    <ColumnInfoButton text={titleInfo} />
                )}
                <span className="badge bg-secondary ms-auto">{totalCount}</span>
            </div>
            <div className="management-column__body">
                {loading ? (
                    <div className="d-flex justify-content-center align-items-center h-100">
                        <Spinner animation="border" size="sm" />
                    </div>
                ) : (
                    <div className="column-subcolumns">
                        <SubColumn
                            title="Felanmälningar"
                            count={issueCount}
                            emptyMessage="Inga felanmälningar"
                            footer={issueFooter}
                        >
                            {issueItems}
                        </SubColumn>
                        <SubColumn
                            title="Underhåll & kontroller"
                            count={maintenanceCount}
                            emptyMessage="Inga underhåll eller kontroller"
                            footer={maintenanceFooter}
                        >
                            {maintenanceItems}
                        </SubColumn>
                    </div>
                )}
            </div>
        </div>
    );
};

export default IncomingColumn;
